import Helmet from "react-helmet";

import GlobalStyles from "@mui/material/GlobalStyles";

import { getPageTitle } from "@utils";

import DashboardPageContent from "./DashboardPageContent";

export default function Dashboard() {
  return (
    <>
      <Helmet>
        <title>{getPageTitle("Dashboard")}</title>
      </Helmet>
      {/* Body scroll is disabled on desktop by default (see index.css); the dashboard can list multiple residents, so it needs to scroll. */}
      <GlobalStyles styles={{ "html body": { overflowY: "scroll" } }} />
      <DashboardPageContent />
    </>
  );
}
